module.exports = __webpack_public_path__ + "static/media/ls.79261c08.svg";